import _classCallCheck from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.string.includes.js";
import { noop } from "../../utils/event.js";
function getBlockElement(el, parent) {
  if (parent && el === parent) {
    return null;
  }
  var nodeName = el.nodeName.toLowerCase();
  if (['div', 'li', 'ul', 'ol', 'blockquote'].includes(nodeName) === true) {
    return el;
  }
  var style = window.getComputedStyle ? window.getComputedStyle(el) : el.currentStyle,
    display = style.display;
  if (display === 'block' || display === 'table') {
    return el;
  }
  return getBlockElement(el.parentNode);
}
function isChildOf(el, parent, orSame) {
  return !el || el === document.body ? false : orSame === true && el === parent || (parent === document ? document.body : parent).contains(el.parentNode);
}
function createRange(node, chars, range) {
  if (!range) {
    range = document.createRange();
    range.selectNode(node);
    range.setStart(node, 0);
  }
  if (chars.count === 0) {
    range.setEnd(node, chars.count);
  } else if (chars.count > 0) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.length < chars.count) {
        chars.count -= node.textContent.length;
      } else {
        range.setEnd(node, chars.count);
        chars.count = 0;
      }
    } else {
      for (var lp = 0; chars.count !== 0 && lp < node.childNodes.length; lp++) {
        range = createRange(node.childNodes[lp], chars, range);
      }
    }
  }
  return range;
}
var urlRegex = /^https?:\/\//;
export var Caret = /*#__PURE__*/function () {
  function Caret(el, vm) {
    _classCallCheck(this, Caret);
    this.el = el;
    this.vm = vm;
    this._range = null;
  }
  _createClass(Caret, [{
    key: "selection",
    get: function get() {
      if (this.el) {
        var sel = document.getSelection();

        // only when the selection in element
        if (isChildOf(sel.anchorNode, this.el, true) && isChildOf(sel.focusNode, this.el, true)) {
          return sel;
        }
      }
      return null;
    }
  }, {
    key: "hasSelection",
    get: function get() {
      return this.selection !== null ? this.selection.toString().length > 0 : false;
    }
  }, {
    key: "range",
    get: function get() {
      var sel = this.selection;
      if (sel !== null && sel.rangeCount) {
        return sel.getRangeAt(0);
      }
      return this._range;
    }
  }, {
    key: "parent",
    get: function get() {
      var range = this.range;
      if (range !== null) {
        var node = range.startContainer;
        return node.nodeType === document.ELEMENT_NODE ? node : node.parentNode;
      }
      return null;
    }
  }, {
    key: "blockParent",
    get: function get() {
      var parent = this.parent;
      if (parent !== null) {
        return getBlockElement(parent, this.el);
      }
      return null;
    }
  }, {
    key: "save",
    value: function save() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.range;
      if (range !== null) {
        this._range = range;
      }
    }
  }, {
    key: "restore",
    value: function restore() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._range;
      var r = document.createRange(),
        sel = document.getSelection();
      if (range !== null) {
        r.setStart(range.startContainer, range.startOffset);
        r.setEnd(range.endContainer, range.endOffset);
        sel.removeAllRanges();
        sel.addRange(r);
      } else {
        sel.selectAllChildren(this.el);
        sel.collapseToEnd();
      }
    }
  }, {
    key: "savePosition",
    value: function savePosition() {
      var charCount = -1,
        node;
      var selection = document.getSelection(),
        parentEl = this.el.parentNode;
      if (selection.focusNode && isChildOf(selection.focusNode, parentEl)) {
        node = selection.focusNode;
        charCount = selection.focusOffset;
        while (node && node !== parentEl) {
          if (node !== this.el && node.previousSibling) {
            node = node.previousSibling;
            charCount += node.textContent.length;
          } else {
            node = node.parentNode;
          }
        }
      }
      this.savedPos = charCount;
    }
  }, {
    key: "restorePosition",
    value: function restorePosition() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this.savedPos > 0 && this.savedPos < length) {
        var selection = window.getSelection(),
          range = createRange(this.el, {
            count: this.savedPos
          });
        if (range) {
          range.collapse(false);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    }
  }, {
    key: "hasParent",
    value: function hasParent(name, spanLevel) {
      var el = spanLevel ? this.parent : this.blockParent;
      return el !== null ? el.nodeName.toLowerCase() === name.toLowerCase() : false;
    }
  }, {
    key: "hasParents",
    value: function hasParents(list, recursive) {
      var el = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.parent;
      if (el === null) {
        return false;
      }
      if (list.includes(el.nodeName.toLowerCase()) === true) {
        return true;
      }
      return recursive === true ? this.hasParents(list, recursive, el.parentNode) : false;
    }
  }, {
    key: "is",
    value: function is(cmd, param) {
      if (this.selection === null) {
        return false;
      }
      switch (cmd) {
        case 'formatBlock':
          if (param === 'DIV' && this.parent === this.el) {
            return true;
          }
          return this.hasParent(param, param === 'PRE');
        case 'link':
          return this.hasParent('A', true);
        case 'fontSize':
          return document.queryCommandValue(cmd) === param;
        case 'fontName':
          var res = document.queryCommandValue(cmd);
          return res === "\"".concat(param, "\"") || res === param;
        case 'fullscreen':
          return this.vm.inFullscreen;
        case 'viewsource':
          return this.vm.isViewingSource;
        case void 0:
          return false;
        default:
          var state = document.queryCommandState(cmd);
          return param !== void 0 ? state === param : state;
      }
    }
  }, {
    key: "getParentAttribute",
    value: function getParentAttribute(attrib) {
      if (this.parent !== null) {
        return this.parent.getAttribute(attrib);
      }
      return null;
    }
  }, {
    key: "can",
    value: function can(name) {
      if (name === 'outdent') {
        return this.hasParents(['blockquote', 'li'], true);
      }
      if (name === 'indent') {
        return this.hasParents(['li'], true);
      }
      if (name === 'link') {
        return this.selection !== null || this.is('link');
      }
    }
  }, {
    key: "apply",
    value: function apply(cmd, param) {
      var done = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;
      if (cmd === 'formatBlock') {
        if (['BLOCKQUOTE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(param) && this.is(cmd, param)) {
          cmd = 'outdent';
          param = null;
        }
        if (param === 'PRE' && this.is(cmd, 'PRE')) {
          param = 'P';
        }
      } else if (cmd === 'print') {
        done();
        var win = window.open();
        win.document.write("\n        <!doctype html>\n        <html>\n          <head>\n            <title>Print - ".concat(document.title, "</title>\n          </head>\n          <body>\n            <div>").concat(this.el.innerHTML, "</div>\n          </body>\n        </html>\n      "));
        win.print();
        win.close();
        return;
      } else if (cmd === 'link') {
        var link = this.getParentAttribute('href');
        if (link === null) {
          var selection = this.selectWord(this.selection);
          var url = selection ? selection.toString() : '';
          if (!url.length) {
            if (!this.range || !this.range.cloneContents().querySelector('img')) {
              return;
            }
          }
          this.vm.editLinkUrl = urlRegex.test(url) ? url : 'https://';
          document.execCommand('createLink', false, this.vm.editLinkUrl);
          this.save(selection.getRangeAt(0));
        } else {
          this.vm.editLinkUrl = link;
          this.range.selectNodeContents(this.parent);
          this.save();
        }
        return;
      } else if (cmd === 'fullscreen') {
        this.vm.toggleFullscreen();
        done();
        return;
      } else if (cmd === 'viewsource') {
        this.vm.isViewingSource = this.vm.isViewingSource === false;
        this.vm.__setContent(this.vm.value);
        done();
        return;
      }
      document.execCommand(cmd, false, param);
      done();
    }
  }, {
    key: "selectWord",
    value: function selectWord(sel) {
      if (sel === null || sel.isCollapsed !== true || /* IE 11 */sel.modify === void 0) {
        return sel;
      }

      // Detect if selection is backwards
      var range = document.createRange();
      range.setStart(sel.anchorNode, sel.anchorOffset);
      range.setEnd(sel.focusNode, sel.focusOffset);
      var direction = range.collapsed ? ['backward', 'forward'] : ['forward', 'backward'];
      range.detach();

      // modify() works on the focus of the selection
      var endNode = sel.focusNode,
        endOffset = sel.focusOffset;
      sel.collapse(sel.anchorNode, sel.anchorOffset);
      sel.modify('move', direction[0], 'character');
      sel.modify('move', direction[1], 'word');
      sel.extend(endNode, endOffset);
      sel.modify('extend', direction[1], 'character');
      sel.modify('extend', direction[0], 'word');
      return sel;
    }
  }]);
  return Caret;
}();